module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chap",
    attrs: {
      "id": "acknowledgments"
    }
  }, [_c('p', {
    staticClass: "ct"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/OEBPS/pppdrop005#toc"
    }
  }, [_vm._v("Acknowledgments")])]), _vm._v(" "), _c('p', {
    staticClass: "pf"
  }, [_vm._v("Love and thanks to my siblings: Chris, brother and web master; the “real” Martha, and Carol, who helped me reconstruct our mother’s recipe for okra pie. I especially want to express my gratitude to my cousins the Morgans, Charles Lee and his wife, Jean, for inviting me to visit the farm outside of Boynton for the first time in almost thirty years. If I hadn’t spent so much magical time on that farm when I was a child, these books would not exist. Thanks also to June Smith and Ardith McKeaigg for hosting me so graciously when I spoke at the Boynton Historical Society.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0a67d025","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/OEBPS/ppp-drop006.vue
// module id = 75
// module chunks = 0